import {
  SNACKBAR_SET_MESSAGE,
  SNACKBAR_CLEAR_MESSAGE,
  ALERT_BAR_CLOSE,
} from "../actions/types"

const INITIAL_STATE = {
  snackbar: {
    message: "",
    variant: "info",
    timestamp: new Date().valueOf(),
    autoHideDuration: 4000,
  },
  alertBarClosed: false,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SNACKBAR_SET_MESSAGE:
      return { ...state, snackbar: action.payload }
    case SNACKBAR_CLEAR_MESSAGE:
      return { ...state, snackbar: INITIAL_STATE.snackbar }
    case ALERT_BAR_CLOSE:
      return { ...state, alertBarClosed: true }
    default:
      return state
  }
}
